import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';

import {catchError, NEVER, Observable, takeUntil, throwError} from 'rxjs';
import {environment} from "@environments/environment";
import {AuthService} from "@core/authentication/auth.service";
import {HEADER_STATUS_CODE, REQUEST_HEADER_APP_VERSION, REQUEST_HEADER_AUTHORIZATION} from "@core/constants";
import {uriConsts} from "@shared/constants";

// Chỉ handshake đăng nhập và khôi phục phiên được bỏ token.
// Callback kết nối kênh cần token của user đang đăng nhập để BE kiểm tra CSRF.
const AUTH_ENDPOINTS_WITHOUT_ACCESS_TOKEN = new Set<string>([
  uriConsts.auth.callback,
  uriConsts.auth.refresh,
]);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    @Inject(AuthService) private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiUrl = req.url.startsWith(environment.baseUrlApi);
    // Ads portal gắn token riêng qua AdsAuthInterceptor
    if (!isApiUrl || environment.isAdsModule) {
      return next.handle(req);
    }

    const path = req.url.slice(environment.baseUrlApi.length).split('?')[0];
    const headers: { [name: string]: string } = {
      [REQUEST_HEADER_APP_VERSION]: environment.apiVersion.toString()
    };
    const authorizationToken = this.authService.getAuthorizationToken();
    if (authorizationToken && !AUTH_ENDPOINTS_WITHOUT_ACCESS_TOKEN.has(path)) {
      headers[REQUEST_HEADER_AUTHORIZATION] = authorizationToken;
    }

    req = req.clone({
      setHeaders: headers
    });

    return next.handle(req).pipe(
      // Response của phiên cũ không được ghi lại usr sau khi logout/reset auth.
      takeUntil(path === '/auth/logout' ? NEVER : this.authService.onAuthCleared$),
      catchError((error: HttpErrorResponse) => {
        if (this.authService.isLoggingOut || path !== uriConsts.auth.login || req.method !== 'POST'
          || error.status !== HEADER_STATUS_CODE.FORBIDDEN) {
          return throwError(() => error);
        }

        // Token lưu từ phiên cũ có thể lệch CSRF. Xóa riêng cache user và thử
        // khởi tạo đăng nhập lại một lần; lỗi lần hai được trả về như bình thường.
        this.authService.clearCachedAuthUser();
        const retryRequest = req.clone({
          headers: req.headers.delete(REQUEST_HEADER_AUTHORIZATION),
        });
        return next.handle(retryRequest).pipe(takeUntil(this.authService.onAuthCleared$));
      }),
    );
  }
}
